export enum SourceOfResource {
    AdminAPI,
    S3,
    JSONInCodeBase,
}